import * as log from '@/model/util/log/Logger'
import { setHeightVh } from './domResizeCss'

/**
 * リサイズ初期設定 イベントの登録と高さ設定を実施する
 */
const initResize = () => {
  // リサイズ時のイベント登録
  window.addEventListener('resize', () => {
    log.debug('resize.')
    setHeightVh()
  })
  // 画面回転のイベント登録 横 ⇒ 縦にした場合にresizeのみだとうまく動作しなかったので設定する
  window.addEventListener('orientationchange', () => {
    log.debug('orientationchange.')
    setHeightVh()
  })
  // 高さ設定
  setHeightVh()
}

export { initResize }
